"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.Formulas = void 0;
var _formulas = require("./formulas");
exports.PLUGIN_KEY = _formulas.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _formulas.PLUGIN_PRIORITY;
exports.Formulas = _formulas.Formulas;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/formulas/index.js
// module id = 1421
// module chunks = 0